import React from 'react';
import {
  BrowserRouter, Route, Routes, useLocation, useParams, useMatch
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { generateRoutesData } from './routes_utils';
import Navigation from '../navigation';
import CommonLogicComponent from '../common_logic_component';

const Overlays = React.lazy(() => import('./overlays'));
const Spinner = React.lazy(() => import('../spinner'));

function RenderRoutes({ currentScreen }) {
  const location = useLocation();
  const useSpinnerRoutes = !currentScreen;
  const generatedData = generateRoutesData(useSpinnerRoutes);

  const routes = Object.keys(generatedData).map((key, i) => {
    const { path, Component } = generatedData[key];
    const params = useParams();
    const match = useMatch(`${ path }`, { end: true });

    return (
      <Route
        key={ i }
        path={ path }
        element={ <Component location={ location } params={ params } match={ match } /> }
        exact
      />
    );
  });

  return <Routes>{routes.map((r) => r)}</Routes>;
}

function RoutesComponent(params) {
  return (
    <React.Suspense fallback={ <Spinner /> }>
      <BrowserRouter>
        <RenderRoutes { ...params } />
        <Navigation { ...params } />
      </BrowserRouter>
      <CommonLogicComponent />
      <Overlays />
    </React.Suspense>
  );
}

RenderRoutes.propTypes = {
  currentScreen: PropTypes.object
};

RenderRoutes.defaultProps = {
  currentScreen: null
};

export default RoutesComponent;
